import { ShoppingListIngredientDetail } from "@/clients/models/ShoppingListIngredientDetail";
import { cn } from "@/utils/cn";
import { memo } from "react";
import AisleFilterTabButton from "./aisle-filter-tab-button";

interface AisleFilterTabButtonsProps {
  aisles: string[];
  selectedAisle: string | null;
  groupedIngredients: Map<string, ShoppingListIngredientDetail[]>;
}

export const AisleFilterTabButtons = memo(function AisleFilterButtons({
  aisles,
  selectedAisle,
  groupedIngredients,
}: AisleFilterTabButtonsProps) {
  return (
    <div
      className={cn(
        "w-full h-14 flex-shrink-0 overflow-x-scroll no-scrollbar",
        "flex flex-row items-center gap-2",
      )}
    >
      {aisles.map((aisle) => {
        const isActive = selectedAisle === aisle;

        return (
          <AisleFilterTabButton
            key={aisle}
            aisle={aisle}
            isActive={isActive}
            ingredients={groupedIngredients.get(aisle) ?? []}
          />
        );
      })}
    </div>
  );
});
